// extracted by mini-css-extract-plugin
export default {"counterBox":"Counter_counterBox__qWH+C","counter":"Counter_counter__QpcrM","item":"Counter_item__3IjLX","number":"Counter_number__0rEUe","text":"Counter_text__xKoWA"};